module.exports = __webpack_public_path__ + "static/img/280.69739131.png";